import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var appointmentDelete = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var request_id, _ref$cancellation_rea, cancellation_reason_id, _ref$note, note, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          request_id = _ref.request_id, _ref$cancellation_rea = _ref.cancellation_reason_id, cancellation_reason_id = _ref$cancellation_rea === void 0 ? "1" : _ref$cancellation_rea, _ref$note = _ref.note, note = _ref$note === void 0 ? "text" : _ref$note;
          params = {
            request_id: request_id,
            cancellation_reason_id: cancellation_reason_id,
            note: note
          };
          _context.n = 1;
          return erpFetcher(null, true).post('inspection-appointment/cancel', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function appointmentDelete(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default appointmentDelete;